import React from "react";
import { SRLWrapper } from "simple-react-lightbox";

export const UniversalJapan = () => {
  let pictures = [];
  for (let i = 1; i <= 5; i++) {
    pictures.push(
      require(`../../../Assets/img/photos/commissions/universal-studio-japan/universal-studio-japan-${i}.jpg`)
    );
  }
  return (
    <div className="commissions-content">
      <p className="commissions-description">
        Apa sih yang terlintas di benak kalian ketika mendengar ‘Universal
        Studios Japan’ ? Kalo aku pribadi, mendengarnya saja langsung bisa
        membangkitkan mood : sounds like a super fun Theme Park! Apalagi aku
        sebagai penikmat hampir semua film-film animasi dari Universal studios.
        Setelah searching-searching di google, aku semakin dibuat penasaran
        dengan semua atraksi yang ditawarkan oleh Universal Studios Japan.
        <br />
        <br />
        Sampai akhirnyaaa, kesempatan itu datang juga! Tanggal 9 Mei 2019 lalu,
        aku langsung merasakan euphoria setiap wahananya. Seru? It was sooo much
        fun! Incredibly awesome deh kalo kata orang-orang bule! Nah di tulisanku
        kali ini, aku mau review lebih detail pengalaman di 3 Wahana yang jadi
        andalannya Universal Studios Japan.
      </p>
      <SRLWrapper>
        <div className="portfolio-pictures-row-portrait">
          {pictures.map((picture, index) => {
            return <img key={`universal-japan-${index}`} src={picture} />;
          })}
        </div>
      </SRLWrapper>
    </div>
  );
};

export default UniversalJapan;
